import React from "react"
import { theme } from "../../../utils/styles"
import { INK } from "./styles"

// Portrait data-terminal visual: two identical row-blocks stacked and
// translated upward forever gives a seamless infinite scroll (no reset
// glitch), with a gold fade top/bottom so values dissolve in/out.
// NOTE: values below are representative enzyme measurements — replace with
// real Scindo measurements before launch.
const COL = [6, 26, 46, 66, 86, 106, 126]

const Rows = ({ id }) => (
  <g id={id} fontFamily="monospace" fontSize="7.5" fill={INK}>
    <text x={COL[0]} y="18">0.94</text><text x={COL[1]} y="18">R</text><text x={COL[2]} y="18">98%</text><text x={COL[3]} y="18">1.2</text><text x={COL[4]} y="18">kcat</text><text x={COL[5]} y="18">7.1</text><text x={COL[6]} y="18">S</text>
    <text x={COL[0]} y="34">S</text><text x={COL[1]} y="34">0.31</text><text x={COL[2]} y="34">7.4</text><text x={COL[3]} y="34">37</text><text x={COL[4]} y="34">ee</text><text x={COL[5]} y="34">0.5</text><text x={COL[6]} y="34">R</text>
    <text x={COL[0]} y="50">4.2</text><text x={COL[1]} y="50">ee</text><text x={COL[2]} y="50">0.88</text><text x={COL[3]} y="50">R</text><text x={COL[4]} y="50">pH</text><text x={COL[5]} y="50">2.1</text><text x={COL[6]} y="50">0.9</text>
    <text x={COL[0]} y="66">pH</text><text x={COL[1]} y="66">2.1</text><text x={COL[2]} y="66">S</text><text x={COL[3]} y="66">0.5</text><text x={COL[4]} y="66">Km</text><text x={COL[5]} y="66">8.1</text><text x={COL[6]} y="66">R</text>
    <text x={COL[0]} y="82">0.77</text><text x={COL[1]} y="82">1.9</text><text x={COL[2]} y="82">kcat</text><text x={COL[3]} y="82">R</text><text x={COL[4]} y="82">96%</text><text x={COL[5]} y="82">S</text><text x={COL[6]} y="82">3.6</text>
    <text x={COL[0]} y="98">96%</text><text x={COL[1]} y="98">S</text><text x={COL[2]} y="98">3.4</text><text x={COL[3]} y="98">7.1</text><text x={COL[4]} y="98">0.62</text><text x={COL[5]} y="98">R</text><text x={COL[6]} y="98">ee</text>
    <text x={COL[0]} y="114">0.62</text><text x={COL[1]} y="114">R</text><text x={COL[2]} y="114">ee</text><text x={COL[3]} y="114">42</text><text x={COL[4]} y="114">Km</text><text x={COL[5]} y="114">9.3</text><text x={COL[6]} y="114">S</text>
    <text x={COL[0]} y="130">Km</text><text x={COL[1]} y="130">8.9</text><text x={COL[2]} y="130">S</text><text x={COL[3]} y="130">0.4</text><text x={COL[4]} y="130">1.05</text><text x={COL[5]} y="130">R</text><text x={COL[6]} y="130">99%</text>
    <text x={COL[0]} y="146">1.05</text><text x={COL[1]} y="146">R</text><text x={COL[2]} y="146">99%</text><text x={COL[3]} y="146">pH</text><text x={COL[4]} y="146">5.7</text><text x={COL[5]} y="146">S</text><text x={COL[6]} y="146">0.28</text>
    <text x={COL[0]} y="162">5.7</text><text x={COL[1]} y="162">S</text><text x={COL[2]} y="162">0.28</text><text x={COL[3]} y="162">36</text><text x={COL[4]} y="162">ee</text><text x={COL[5]} y="162">92%</text><text x={COL[6]} y="162">R</text>
    <text x={COL[0]} y="178">ee</text><text x={COL[1]} y="178">92%</text><text x={COL[2]} y="178">2.4</text><text x={COL[3]} y="178">R</text><text x={COL[4]} y="178">0.94</text><text x={COL[5]} y="178">kcat</text><text x={COL[6]} y="178">1.1</text>
  </g>
)

const DataTerminal = () => (
  <div style={{ width: 150, height: 180 }}>
    <svg
      viewBox="0 0 150 180"
      width="150"
      height="180"
      preserveAspectRatio="xMidYMid meet"
      role="img"
      aria-label="A continuously streaming data terminal of enzyme measurements."
    >
      <defs>
        <clipPath id="twg-scr">
          <rect x="4" y="4" width="142" height="172" rx="9" />
        </clipPath>
        <linearGradient id="twg-fade" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={theme.primary} stopOpacity="1" />
          <stop offset="12%" stopColor={theme.primary} stopOpacity="0" />
          <stop offset="88%" stopColor={theme.primary} stopOpacity="0" />
          <stop offset="100%" stopColor={theme.primary} stopOpacity="1" />
        </linearGradient>
      </defs>
      <g clipPath="url(#twg-scr)">
        <g stroke={INK} strokeWidth="0.5" opacity="0.15">
          <line x1="24.3" y1="4" x2="24.3" y2="176" />
          <line x1="44.6" y1="4" x2="44.6" y2="176" />
          <line x1="64.9" y1="4" x2="64.9" y2="176" />
          <line x1="85.1" y1="4" x2="85.1" y2="176" />
          <line x1="105.4" y1="4" x2="105.4" y2="176" />
          <line x1="125.7" y1="4" x2="125.7" y2="176" />
        </g>
        <g>
          <animateTransform
            attributeName="transform"
            type="translate"
            values="0 0; 0 -176"
            dur="5s"
            repeatCount="indefinite"
            calcMode="linear"
          />
          <Rows id="twg-rows" />
          <use href="#twg-rows" transform="translate(0 176)" />
        </g>
        <rect x="4" y="4" width="142" height="172" fill="url(#twg-fade)" />
      </g>
      <rect x="4" y="4" width="142" height="172" rx="9" fill="none" stroke={INK} strokeWidth="1.5" />
    </svg>
  </div>
)

export default DataTerminal
